import React from 'react'
import './Reg.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Reg = () => {
  const navigate= useNavigate();

  const [ userData, setUserData ] = useState();
  const [loadingMsg, setLoadingMsg] = useState('Register');
  const [user, setUser] = useState({
    name: '',
    phone: '',
    email: '',
    rollno: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  
  const RegisterUser = async (e) => {
    e.preventDefault();
    setLoadingMsg('Registering...');

    const { name, phone, email, rollno } = user;

    try {
      const res = await fetch('https://registration-page-iete.vercel.app/user/register', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          phone,
          email,
          rollno
        }),
      });

      const data = await res.json();

      if (res.status === 422) {
        setLoadingMsg('Register');
        window.alert('Empty fields or user already registered!');
      } else {
        setLoadingMsg('Register');
        navigate('/success');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
  <>
    <div className="main">
      <div className="heading">
        <h1> IETE ORIENTATION </h1>
        {/* <h1> XX SEP '23 </h1> */}
      </div>
      <img id='logo_IETE' src="assets/IETE_logo.jpg" alt="IETE_logo" />

      <div className="form">

        <label htmlFor="name">Name</label><input type="text" className='formData' placeholder='Name' name="name" onChange={handleChange}/>
        <label htmlFor="phone_no">Phone no.</label><input type="number" className='formData'n placeholder='Phone no.' name="phone"  onChange={handleChange}/>
        <label htmlFor="email">Email Address</label><input type="email" className='formData' placeholder='Email Address' name="email"  onChange={handleChange}/>
        <label htmlFor="admission_no">RollNo/AdmissionNo</label><input type="number" className='formData' placeholder='Admission no.' name="rollno"  onChange={handleChange}/>
      </div>
      <button id="btn" onClick={RegisterUser} >{loadingMsg}</button>
    </div>
  </>
);
  }
  export default Reg